class UserPreferences {
  constructor() {
    this.bindEvents()
  }

  get prefersReducedMotion() {
    return this._prefersReducedMotion
  }

  set prefersReducedMotion(value) {
    this._prefersReducedMotion = value
  }

  bindEvents() {
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)')
    this.prefersReducedMotion = prefersReducedMotion.matches

    if (typeof prefersReducedMotion.addEventListener !== 'function') return

    prefersReducedMotion.addEventListener('change', () => {
      this.prefersReducedMotion = prefersReducedMotion.matches
    })
  }
}

export default new UserPreferences()
